import {TModelMappingValueOriginType} from "~/interfaces/mappingInterfaces";
import {ModelType} from "~/enums/modelType";
import ModelMappingValueOriginFormElement from "~/models/mapping/modelMappingValueOriginFormElement";
import ModelMappingValueOriginObjectModelProperty from "~/models/mapping/modelMappingValueOriginObjectModelProperty";
import ModelMappingValueOriginSalesforce from "~/models/mapping/modelMappingValueOriginSalesforce";
import ModelMappingOrigin from "~/models/mapping/modelMappingOrigin";
import assertNever from "../../../global/assetNever";
import ModelMappingValueOrigin from "~/models/mapping/modelMappingValueOrigin";
import {Constructor} from "../../../global/constructor";
import ModelMappingValueOriginSChildRelationship from "~/models/mapping/modelMappingValueOriginSChildRelationship";
import ModelMappingValueOriginSReferenceField from "~/models/mapping/modelMappingValueOriginSReferenceField";
import ModelMappingValueOriginLookupField from "~/models/mapping/modelMappingValueOriginLookupField";
import ModelMappingValueOriginRelationIdentifier from "~/models/mapping/modelMappingValueOriginRelationIdentifier";
import ModelMappingValueOriginPaymentStep from "~/models/mapping/modelMappingValueOriginPaymentStep";
import ModelMappingValueOriginPaymentStepLineItem from "~/models/mapping/modelMappingValueOriginPaymentStepLineItem";

export default class ModelMappingValueOriginFactory {
  static getClass(type: TModelMappingValueOriginType) {
    switch (type) {
      case  ModelType.Form:
        return ModelMappingValueOriginFormElement
      case  ModelType.FormElement:
        return ModelMappingValueOriginFormElement
      case  ModelType.LookUpField:
        return ModelMappingValueOriginLookupField
      case  ModelType.PaymentStep:
        return ModelMappingValueOriginPaymentStep
      case  ModelType.PaymentStepLineItem:
        return ModelMappingValueOriginPaymentStepLineItem
      case ModelType.RelationIdentifier:
        return ModelMappingValueOriginRelationIdentifier
      case ModelType.ObjectModel:
        return ModelMappingValueOriginObjectModelProperty
      case ModelType.SObject:
        return ModelMappingValueOriginSalesforce
      case ModelType.SObjectChildRelationship:
        return ModelMappingValueOriginSChildRelationship
      case ModelType.SObjectReferenceField:
        return ModelMappingValueOriginSReferenceField
      default:
        assertNever(type)
    }
  }

  static create(type: TModelMappingValueOriginType, id: string, modelMappingOrigin: ModelMappingOrigin) {
    let klass: Constructor<ModelMappingValueOrigin> = ModelMappingValueOriginFactory.getClass(type)
    return new klass(id, modelMappingOrigin)
  }
}